import * as services from '.';
export const allServices = [
  services.DetailsPopupService,
  services.EntitiesServiceService,
  services.InputFetchService,
  services.LaneBulbService,
  services.LoaderService,
  services.ModelLoaderService,
  services.MonotainerService,
  services.PopOverTemplatesService,
  services.SceneService,
  services.TagUntagService,
  services.FormService,
  services.GeneralService,
  services.EntitySiteService,
  services.DialogService,
  services.TableViewDrawerService,
  services.PlanogramSharedService,
];
